import { Component } from '@angular/core';
import { SyncService } from '../../sync.service';
import { HttpService } from '../../http.service';

@Component({
  selector: 'delete-file-modal',
  templateUrl: './delete-file-modal.component.html',
  styleUrls: ['./delete-file-modal.component.css']
})
export class DeleteFileModalComponent {

	userData: any = {};

	constructor(
		private httpService: HttpService,
		private syncService: SyncService,
	) {}

	deleteFileModalOpen = false;
	filePendingDeletion: any;

	ngOnInit(): void {
		this.syncService.fileDeletionModalOpen$.subscribe((data) => {
			this.deleteFileModalOpen = data;
		});
		this.syncService.filePendingDeletion$.subscribe((data) => {
			this.filePendingDeletion = data;
		});
		this.syncService.userData$.subscribe((data) => {
			this.userData = data;
		});
	}

	deleteFile() {
		this.syncService.updateFileDeletionModalOpen(false);
		this.httpService.reloadUserData(false);
		for (let i = 0; i < this.userData['Deals'].length; i++) {
			if (this.userData['Deals'][i]['Deal Name'] === this.filePendingDeletion['Deal Name']) {
				this.userData['Deals'][i]['Files'] = this.userData['Deals'][i]['Files'].filter((file: any) => file !== this.filePendingDeletion);
			}
		}
		this.httpService.deleteFile(this.userData['Workspace'], this.filePendingDeletion['Deal Name'], this.filePendingDeletion['File Name'])
		this.syncService.updateUserData(this.userData); // DELETE FILE
		this.syncService.updateDealDeletionModalOpen(false);
		this.syncService.updatePage('files');
	}

}
